import LTR from "@brand-icons/global/product-package/product-package-ltr.svg";
import RTL from "@brand-icons/global/product-package/product-package-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ProductPackageIcon = iconFactory("ProductPackageIcon", LTR, RTL);
